<core-debug-ui-items>
  <div class="monitoring" #monitoring></div>
</core-debug-ui-items>
